import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface LoadingProps { height?: string; } 

import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'VueLoading'
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    height: { default: '100vh' }
  },
  setup(__props: any) {
 
const props = __props; 

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex align-center justify-center",
    style: _normalizeStyle(`height: ${__props.height}`)
  }, [
    _createVNode(_component_v_progress_circular, {
      indeterminate: "",
      color: "primary"
    })
  ], 4))
}
}

})